import { env } from 'core/constants/env.constants';
import { AuthContextProps } from 'oidc-react';

export const setInactivityTimeout = (auth: AuthContextProps) => {
    const idleDurationMinutes: number = Number(env.VITE_INACTIVITY_TIMEOUT);
    let idleTimeout: NodeJS.Timeout;
    const eventsToCapture = ['mousedown', 'touchstart', 'mousemove', 'keydown', 'scroll'];

    const resetIdleTimeout = function () {
        if (idleTimeout) {
            clearTimeout(idleTimeout);
        }
        idleTimeout = setTimeout(() => auth.signOutRedirect(), idleDurationMinutes * 1000 * 60);
    };

    resetIdleTimeout();

    eventsToCapture.forEach((evt) => document.addEventListener(evt, resetIdleTimeout, false));
};
